module.exports = __webpack_public_path__ + "img/t-1.c2f81fb0.png";